import { render, staticRenderFns } from "./RejectNoticeOfPrivacy.vue?vue&type=template&id=40c1821e&"
import script from "./RejectNoticeOfPrivacy.vue?vue&type=script&lang=js&"
export * from "./RejectNoticeOfPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QPageContainer,QPage,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QHeader,QToolbar,QPageContainer,QPage,QCard,QCardSection})
